import React from 'react'

const ExpiringStock = () => {
  return (
    <>
      <section className="content">
        <div className="container-fluid">
          <h1 className='comesoon'> Coming Soon! </h1>
        </div>
      </section>

    </>
  )
}

export default ExpiringStock